import { render, staticRenderFns } from "./communityRoomTree.vue?vue&type=template&id=073f8008&scoped=true"
import script from "./communityRoomTree.vue?vue&type=script&lang=js"
export * from "./communityRoomTree.vue?vue&type=script&lang=js"
import style0 from "./communityRoomTree.vue?vue&type=style&index=0&id=073f8008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073f8008",
  null
  
)

export default component.exports